import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomToolbar from "../../../components/Tools/CustomeToolbar";
import moment from "moment";
import View from "./View";
import DateInput from "../../../components/Form/DateInput";
import { useForm, useWatch } from "react-hook-form";
import StatusSelector from "../../../components/Form/Status";
import PageHeader from "../../../components/PageHeader/PageHeader";
import AssignTo from "../../../components/Form/AssignTo";
import useAssignees from "../../../components/CommonFunctions/Usres";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Delete from "../../../components/Popup/Delete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Waveform } from "@uiball/loaders";
import Create from "../Leads/create";
import { GlobalRefreshContext } from "../../../contexts/GlobalRefresh/GlobalRefresh";
import StatusLIstFunction from "../../../components/CommonFunctions/statusLIst";
import { SiteVisitsAPI } from "../../../api/Endpoints/SiteVisitsAPI";
import CloseLeadPopup from "../../../components/Popup/ClosedLead";
import ArchiveIcon from "@mui/icons-material/Archive";
import ClearIcon from "@mui/icons-material/Clear";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import SelectX from "../../../components/Form/SelectX";
import {
  fetchAssignees as loadAssigneeOptions,
  fetchLeadSources,
  fetchProjects,
} from "../../../components/CommonFunctions/DropdownLists";

/** Match Leads list: assigned_users is an array of user ids (same as filterData.assigned_to). */
function normalizeAssignedUserIds(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((u) => (u && typeof u === "object" ? u.id : u))
      .filter((id) => id != null && id !== "");
  }
  if (typeof raw === "object") {
    return raw.id != null ? [raw.id] : [];
  }
  return [];
}

function normalizeLeadSourceNames(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) {
    return raw
      .map((s) => (s && typeof s === "object" ? s.name : s))
      .filter(Boolean);
  }
  return [];
}

export default function SiteVisitsPage() {
  const leadTypeData = JSON.parse(sessionStorage.getItem("Lead_type"));
  const projectData = JSON.parse(sessionStorage.getItem("project"));
  const {
    watch,
    getValues,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    defaultValues: {
      assigned_to: null,
      lead_source: null,
      filter_project: projectData?.ID
        ? { id: projectData.ID, name: projectData.Name }
        : null,
    },
  });

  const filterAssigned = useWatch({ control, name: "assigned_to" });
  const filterSource = useWatch({ control, name: "lead_source" });
  const filterProject = useWatch({ control, name: "filter_project" });

  const columns = [
    {
      field: "name",
      headerName: "Customer Name",
      width: 250,
      renderCell: (params) => (
        <Typography
          size="small"
          sx={{ cursor: "pointer" }}
          onClick={() => viewTabs(params)}
        >
          {params.row.name}
        </Typography>
      ),
    },

    {
      field: "assigned_to_details",
      headerName: "Assign To",
      width: 110,
      renderCell: (params) => (
        <>
          <Button size="small" style={{ color: "#6f6f6f" }}>
            <AssignTo
              id={params.id}
              isAssigned={params.row.assigned_to_details}
              name={`assigned_to_details`}
              setValue={setValue}
              watch={watch}
            />
          </Button>
        </>
      ),
    },
    {
      field: "project_name",
      headerName: "Project Name",
      width: 190,
      renderCell: (params) => {
        return (
          <Typography style={{ color: "#6f6f6f" }}>
            {params.row?.project?.name}
          </Typography>
        );
      },
    },
    {
      field: "source_name",
      headerName: "Source",
      width: 120,
      renderCell: (params) => {
        return (
          <Typography style={{ color: "#6f6f6f" }}>
            {params.row?.source}
          </Typography>
        );
      },
    },
    {
      field: "site_visit_date",
      headerName: "Site Visit",
      width: 150,
      renderCell: (params) => {
        const formattedDate = moment(params.row.site_visit_date).format(
          "DD-MM-YYYY"
        );
        return (
          <Typography style={{ color: "#6f6f6f" }}>{formattedDate}</Typography>
        );
      },
    },
    {
      field: "follow_up_date",
      headerName: "Follow Up",
      width: 160,
      renderCell: (params) => {
        const { id } = params;
        return (
          <DateInput
            id={id}
            name={`follow_up_date-${id}`}
            control={control}
            setValue={setValue}
            watch={watch}
            value={params.row?.follow_up_date}
            func={() => {
              fetchSiteVisitsForTableUpdate();
            }}
            compactTable={true}
          />
        );
      },
    },

    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return (
          <StatusSelector
            statusList={statusList}
            options={params.row?.crm_status_details}
            id={params.id}
            func={fetchSiteVisitsForTableUpdate}
          />
        );
      },
    },

    {
      width: 50,
      renderCell: (params) => <MoreOptionsDropdown params={params} />,
    },
  ];

  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [ViewID, setViewID] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const { assignees, isLoading, fetchAssignees } = useAssignees();
  const [Modal, setModal] = useState(false);
  const [editId, setEditId] = useState(undefined);
  const [DeleteID, setDeleteID] = useState(0);
  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [CloseID, setCloseID] = useState(0);
  const [showClosePopup, setShowClosePopup] = useState(false);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const { GlobalRefresh } = GlobalRefreshContext();
  const [selectedRow, setSelectedRow] = useState([]);
  const { statusList, fetchStatusList } = StatusLIstFunction();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [serachEntry, setSearchEntry] = useState("");

  const buildSiteVisitParams = () => {
    const assignedIds = normalizeAssignedUserIds(getValues("assigned_to"));
    const sourceNames = normalizeLeadSourceNames(getValues("lead_source"));
    const projectFromForm = getValues("filter_project");

    console.log("🔍 Filter Values:");
    console.log("  - assigned_to (raw):", getValues("assigned_to"));
    console.log("  - normalized assignedIds:", assignedIds);
    console.log("  - lead_source (raw):", getValues("lead_source"));
    console.log("  - normalized sourceNames:", sourceNames);
    console.log("  - filter_project:", projectFromForm);

    const params = {
      page: parseInt(paginationModel?.page) + 1,
      from: selectedFromDate
        ? moment(selectedFromDate).format("YYYY-MM-DD")
        : null,
      to: selectedToDate ? moment(selectedToDate).format("YYYY-MM-DD") : null,
      crm_lead_type_id: leadTypeData?.ID,
      project_id: projectFromForm?.id ?? projectData?.ID,
      filter: serachEntry || null,
    };
    if (assignedIds.length > 0) {
      params.assigned_to = assignedIds; // Send as array
    }
    if (sourceNames.length > 0) {
      params.sources = sourceNames; // Send as array with 'sources' parameter
    }
    Object.keys(params).forEach((k) => {
      if (params[k] === null || params[k] === "") {
        delete params[k];
      }
    });

    console.log("📦 Final API Params:", params);
    return params;
  };

  const fetchSiteVisits = async () => {
    try {
      setLoading(true);
      const params = buildSiteVisitParams();
      console.log("🚀 Fetching Site Visits with params:", params);
      const response = await SiteVisitsAPI.getSiteVisit(params);
      console.log("✅ API Response:", response.data);
      setLeads(response.data.leads);
      console.log("SiteVisits table data:", response.data.leads);
      setLoading(false);
    } catch (error) {
      console.error("❌ Error fetching Site Visits:", error);
      console.error("Error message:", error.message);
      console.error("Error response:", error?.response);
      setLoading(false);
    }
  };

  const fetchSiteVisitsForTableUpdate = async () => {
    try {
      const response = await SiteVisitsAPI.getSiteVisit(buildSiteVisitParams());
      setLeads(response.data.leads);
      console.log("SiteVisits table data (refresh):", response.data.leads);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchSiteVisits();
  }, [
    paginationModel,
    selectedToDate,
    selectedFromDate,
    GlobalRefresh,
    serachEntry,
    filterAssigned,
    filterSource,
    filterProject,
  ]);
  useEffect(() => {
    const fromParam = queryParams.get("from");
    const toParam = queryParams.get("to");

    // Set selectedFromDate and selectedToDate based on URL parameters
    setSelectedFromDate(fromParam ? fromParam : null);
    setSelectedToDate(toParam ? toParam : null);
  }, [location.search]);

  useEffect(() => {
    fetchStatusList();
  }, []);

  // More option Funciton

  const MoreOptionsDropdown = ({ params }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleEdit = (id) => {
      setEditId(parseInt(id));
      setModal(true);
      setRefresh(Math.random);
    };

    const handleDelete = (id) => {
      setDeleteID(id);
      handleClose();
    };

    const handleCloseLead = (id) => {
      setCloseID(id);
      setShowClosePopup(true);
    };

    return (
      <>
        <IconButton size="small" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem class="edit-nav-cntr" onClick={() => handleEdit(params.id)}>
            <EditIcon sx={{ fontSize: 14, mr: 1 }} />
            Edit
          </MenuItem>

          <MenuItem
            class="edit-nav-cntr delete-sec"
            onClick={() => handleDelete(params.id)}
          >
            <DeleteIcon sx={{ fontSize: 14, mr: 1 }} />
            Delete
          </MenuItem>

          <MenuItem
            class="edit-nav-cntr"
            onClick={() => handleCloseLead(params.id)}
          >
            <ArchiveIcon sx={{ fontSize: 14, mr: 1 }} />
            Archive
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleCreate = () => {
    setEditId(0);
    setRefresh(Math.random);
  };
  const handleUpdate = () => {
    setPaginationModel();
    setPaginationModel(0);
  };

  const viewTabs = (params) => {
    setViewID(params.id);
    setRefresh(Math.random);
  };

  const handleRowSelection = (newSelection) => {
    setSelectedRow(newSelection);
  };
  const handleRowSelectionDelete = () => {
    if (selectedRow.length > 0) {
      setDeleteID(selectedRow);
    } else {
      toast.warning("Please select a lead to delete", { autoClose: 3000 });
    }
  };
  const clearDatePicker = () => {
    setSelectedFromDate(null);
    setSelectedToDate(null);
    setSearchEntry("");
    setValue("assigned_to", null);
    setValue("lead_source", null);
    setValue(
      "filter_project",
      projectData?.ID ? { id: projectData.ID, name: projectData.Name } : null
    );
  };

  const handleSearchEntry = (event) => {
    setSearchEntry(event.target.value);
    setPaginationModel({
      pageSize: 15,
      page: 0,
    });
  };
  return (
    <div class="page-cntr ">
      {showClosePopup && (
        <CloseLeadPopup
          id={CloseID}
          setShowClosePopup={setShowClosePopup}
          func={fetchSiteVisits}
        />
      )}
      <div class="lead-cntr follo-up-cntr ">
        <PageHeader title={"Site Visits"} total={!loading && leads.total} />

        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Grid container direction="row" mb={2}>
            <Grid item xs={3}>
              <div class="follw-dates">
                <DatePicker
                  value={selectedFromDate}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="From"
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: 'white',
                        },
                      }}
                    />
                  )}
                  onChange={(newValue) => setSelectedFromDate(newValue)}
                  inputFormat="DD/MM/YYYY"
                />
              </div>
            </Grid>

            <Grid item xs={3}>
              <DatePicker
                value={selectedToDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="To"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                      },
                    }}
                  />
                )}
                onChange={(newValue) => setSelectedToDate(newValue)}
                inputFormat="DD/MM/YYYY"
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                variant="outlined"
                placeholder={"Search"}
                color="primary"
                onChange={handleSearchEntry}
                style={{ marginBottom: 4, marginLeft: 10 }}
                value={serachEntry && serachEntry}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                  },
                }}
              />

              <IconButton
                className=""
                sx={{ ml: 2, mt: 1, background: "white" }}
                edge="end"
                onClick={clearDatePicker}
              >
                <ClearIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            spacing={2}
            mb={2}
            sx={{ alignItems: "flex-start" }}
          >
            <Grid item xs={12} sm={6} md={3}>
              <SelectX
                ismultiple
                options={loadAssigneeOptions}
                name="assigned_to"
                placeholder="Assigned To"
                defaultValue={watch("assigned_to")}
                control={control}
                closeMenuOnSelect={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SelectX
                ismultiple
                options={fetchLeadSources}
                name="lead_source"
                placeholder="Source"
                defaultValue={watch("lead_source")}
                control={control}
                closeMenuOnSelect={false}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <SelectX
                closeMenuOnSelect
                options={fetchProjects}
                name="filter_project"
                placeholder="Project"
                defaultValue={watch("filter_project")}
                control={control}
              />
            </Grid>
          </Grid>
        </LocalizationProvider>

        <IconButton
          className="dlt-icon-dash followup"
          sx={{ mr: 2 }}
          edge="end"
          onClick={handleRowSelectionDelete}
        >
          <DeleteIcon className="delete-icon" color="red" />
        </IconButton>

        {/* {
                    loading ? (
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={loading}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    ) : null
                } */}

        {/* Popup's  */}

        <Card sx={{ display: "flex", justifyContent: "start" }}>
          {/* Props Passing  */}
          <View
            from={selectedFromDate && selectedFromDate}
            to={selectedToDate && selectedToDate}
            viewID={ViewID}
            setViewID={setViewID}
            watch={watch}
            control={control}
            isDisable={true}
            setFormValue={setValue}
            statusList={statusList}
            assignees={assignees} //Assignees list ,From AssignUser Api
            func={fetchSiteVisitsForTableUpdate} //Fetch leads funcion to Update the Dom
          />

          <Delete
            DeleteID={DeleteID}
            setDeleteID={setDeleteID}
            Callfunc={fetchSiteVisits}
            url={
              DeleteID.length > 0
                ? "/lead/action/bulk-delete"
                : "/lead/action/delete"
            }
            title={DeleteID.length > 0 ? "these Leads" : "this Lead"}
          />

          {Modal && (
            <Create
              key={refresh}
              onNew={handleCreate}
              onUpdate={handleUpdate}
              editId={editId}
              setEditId={setEditId}
              setModal={setModal}
              disableCtnBtn={true}
              siteVistMenu={true}
            />
          )}
        </Card>

        {/* // {showClosePopup && <CloseLeadPopup id={CloseID} setShowClosePopup={setShowClosePopup} func={fetchLeads} />} */}
        {loading ? (
          <Box
            sx={{
              width: "100%",
              marginTop: 10,
              height: 20,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Waveform size={40} lineWeight={3.5} speed={1} color="blue" />
          </Box>
        ) : (
          <>
            {leads.data && leads.data.length === 0 ? (
              <Typography variant="body1">No follow ups.</Typography>
            ) : (
              <Card
                sx={{ m: 0 }}
                variant="outlined"
                class="lead-table sitvisit-table"
              >
                {typeof leads.data === "object" && (
                  <DataGrid
                    paginationMode="server"
                    rows={leads?.data}
                    paginationModel={paginationModel}
                    columns={columns}
                    rowCount={leads?.total}
                    rowHeight={70}
                    autoHeight={true}
                    scrollbarSize={10}
                    density="comfortable"
                    checkboxSelection
                    onPaginationModelChange={setPaginationModel}
                    onRowSelectionModelChange={handleRowSelection}
                    disableColumnMenu
                    disableRowSelectionOnClick
                    disableExtendRowFullWidth
                  />
                )}
              </Card>
            )}
          </>
        )}
      </div>
    </div>
  );
}
